import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { OfflineBanner } from "./components/OfflineBanner";
import WhatsAppFloatButton from "./components/WhatsAppFloatButton";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import PlanPage from "./pages/PlanPage";
import TripPage from "./pages/TripPage";
import AccountPage from "./pages/AccountPage";
import AdminPage from "./pages/AdminPage";
import AboutPage from "./pages/AboutPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import BudgetPage from "./pages/BudgetPage";
import ChecklistPage from "./pages/ChecklistPage";
import CulturePage from "./pages/CulturePage";
import TripLivePage from "./pages/TripLivePage";
import "./App.css";

const Spinner = () => (
  <div className="min-h-screen flex items-center justify-center" style={{ background: "#F9F6F0" }}>
    <div className="text-center">
      <div className="w-10 h-10 border-2 border-[#C17F59] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
      <p className="text-sm text-[#9A8F86] italic" style={{ fontFamily: "'Lora', Georgia, serif" }}>Chargement...</p>
    </div>
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/plan" element={<ProtectedRoute><PlanPage /></ProtectedRoute>} />
      <Route path="/trip/:id" element={<ProtectedRoute><TripPage /></ProtectedRoute>} />
      <Route path="/trip/:id/live" element={<ProtectedRoute><TripLivePage /></ProtectedRoute>} />
      <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
      <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
      <Route path="/budget" element={<ProtectedRoute><BudgetPage /></ProtectedRoute>} />
      <Route path="/checklist" element={<ProtectedRoute><ChecklistPage /></ProtectedRoute>} />
      <Route path="/culture" element={<ProtectedRoute><CulturePage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <OfflineBanner />
          <AppRoutes />
          <WhatsAppFloatButton />
          <Toaster
            richColors
            position="top-right"
            toastOptions={{
              style: {
                fontFamily: "'Lora', Georgia, serif",
                background: "#F1EBE1",
                border: "1px solid #DCD4C6",
                color: "#2B2623",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}
